<div class="drawer-sidenav-wrapper" [class]="profileSideState() ? 'open-drawer':''">
  <div class="header">
    <mat-icon (click)="closeSideNav()">close</mat-icon>
    <div class="text">
      Profile
    </div>
  </div>
  <div class="content-wrapper">
    <div class="profile-completion">
      <div class="profile-progress-wrapper">
        <app-profile-progress [percentage]="userData()?.profile_complate||0" />
      </div>
      <div class="profile-data-wrapper">
        @if (userData()?.full_name) {
          <div class="name">{{userData()?.full_name}}</div>
        }
        @if (userData()?.email) {
          <div class="email">{{userData()?.email}}</div>
        }
        <div class="complete-profile-wrapper">
          <a (click)="redirect()">
            <button mat-button class="btn">
              Complete Profile
              <mat-icon>chevron_right</mat-icon>
            </button>
          </a>
        </div>
      </div>
    </div>
    <div class="donation-impact-wrapper">
      @for (item of livesImpactedList; track item) {
        <div class="impact-card">
          <div class="numeric-value">{{item.value}}</div>
          <div class="impact-label">{{item.label}}</div>
        </div>
      }
    </div>
    <div class="menu-list">
      @for (item of menuList; track item) {
        <a class="item" (click)="redirectionLogic(item)">
          <div class="menu-icon">
            <img [src]="'/assets/images/header/' + item.iconName + '.svg'" alt="menu icon">
          </div>
          <div class="label">{{item?.label}}</div>
          <div class="icon">
            <mat-icon>chevron_right</mat-icon>
          </div>
        </a>
      }
    </div>
  </div>
</div>